import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import Zone from "@insite/client-framework/Components/Zone";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFlyoutDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetFlyoutDrawerIsOpen";
import setInitialValues from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetInitialValues";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import {
    getCurrencies,
    getFulfillmentLabel,
    getIsPunchOutSession,
    getLanguages,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import setCurrency from "@insite/client-framework/Store/Context/Handlers/SetCurrency";
import setLanguage from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import removeCart from "@insite/client-framework/Store/Data/Carts/Handlers/RemoveCart";
import { getHeader, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { getPageLinkByPageType, LinkModel, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import ShowInventoryToggle, { ShowInventoryToggleStyles } from "@insite/content-library/Components/ShowInventoryToggle";
import ShowPricingToggle, { ShowPricingToggleStyles } from "@insite/content-library/Components/ShowPricingToggle";
import { lastNameStyles } from "@insite/content-library/Widgets/ContactUs/LastName";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { ClickableProps } from "@insite/mobius/Clickable";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Globe from "@insite/mobius/Icons/Globe";
import MapPin from "@insite/mobius/Icons/MapPin";
import Menu from "@insite/mobius/Icons/Menu";
import Link from "@insite/mobius/Link";
// import { MappedLink } from "@insite/mobius/Menu";
/* import PanelMenu, { PanelMenuPresentationProps } from "@insite/mobius/PanelMenu";
import PanelRow, { PanelRowPresentationProps } from "@insite/mobius/PanelMenu/PanelRow"; */
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import omitSingle from "@insite/mobius/utilities/omitSingle";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import filterDrawer from "@tSurya/Handlers/FilterDrawer";
import surHeaderHeight from "@tSurya/Handlers/SurHeaderHeightHandler";
import PanelMenu, { PanelMenuPresentationProps } from "@tSurya/MobiusOverrides/PanelMenu/PanelMenu";
import PanelRow, { PanelRowPresentationProps } from "@tSurya/MobiusOverrides/PanelMenu/PanelRow";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import MGBWBackIcon from "@tSurya/Icons/MGBWBackIcon";
import { MGBWCloseIconSmall } from "@tSurya/Icons/MGBWCloseIcon";
import MGBWMenuIcon from "@tSurya/Icons/MGBWMenuIcon";
import { ImageInternalMenuLinks } from "@tSurya/Overrides/Widgets/Header/MainNavigation";
import { COLORS, ELEMENTS, TYPOGRAPHY } from "@tSurya/theme/design";
import GVMenu from "@tSurya/theme/styleguide/icons/GVMenu";
import { isThemeActive, THEME_IDS } from "@tSurya/theme/themeHelper";
import { Property } from "csstype";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => {
    const headerLinkListLinkFields =
        (getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
            return widget.type === "Header/HeaderLinkList";
        })?.fields.links as LinkModel[]) ?? [];
    const displayPricingAndInventory = state.context.session?.displayPricingAndInventory || false;
    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    return {
        currencies: getCurrencies(state),
        currentCurrencyId: state.context.session.currency?.id,
        currentCurrencySymbol: state.context.session.currency?.currencySymbol,
        languages: getLanguages(state),
        currentLanguage: state.context.session.language,
        isAuthenticated: state.context.session.isAuthenticated,
        firstName: state.context.session?.firstName,
        lastName: state.context.session?.lastName,
        currentLocation: getLocation(state),
        userName: state.context.session?.userName,
        isGuest: state.context.session?.isGuest,
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage"),
        vmiDashboardPageUrl: getPageLinkByPageType(state, "VmiDashboardPage")?.url,
        homePageUrl: getPageLinkByPageType(state, "HomePage")?.url,
        headerLinkListLinkFields,
        showCustomerMenuItem: getSettingsCollection(state).accountSettings.enableWarehousePickup,
        fulfillmentLabel: getFulfillmentLabel(state),
        navDrawerIsOpen: state.components.addressDrawer.navDrawerIsOpen,
        flyoutDrawerIsOpen: state.components.addressDrawer.flyoutDrawerIsOpen,
        isPunchOutSession: getIsPunchOutSession(state),
        headerHeight: state.SURData.headerHeightStore.headerHeight,
        userRole: state.context.session.userRoles,
        isSuryaInternalUser: state.context.session.properties?.isSuryaInternalUser,
        cart: getCurrentCartState(state).value,
        visibilityState: findVisibilityState(state.data.pages.widgetsById),
        displayPricingAndInventoryToggles: displayPricingAndInventory && currentMode === "Storefront",
        userDetails: getBillToState(state, state.context.session.billToId)?.value,
        session: state.context.session,
    };
};

const mapDispatchToProps = {
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
    setFlyoutDrawerIsOpen,
    surHeaderHeight,
    removeCart,
    filterDrawer,
};

interface OwnProps {
    links: MappedLink[];
    showQuickOrder: boolean;
    quickOrderLink: PageLinkModel | undefined;
    displayVmiNavigation?: boolean;
    vmiPageLinks?: (PageLinkModel | undefined)[];
    displayModeSwitch?: boolean;
    currentMode?: string;
    isCompactHeaderFlyout?: boolean;
    id: string;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    rootElementSelector?: string;
    allowOpenParentLinks?: boolean;
}
export interface MappedLink {
    // expanded from content-library/src/widgets/header/MainNavigation.tsx
    title: string;
    url?: string;
    type?: string;
    clickableProps?: ClickableProps;
    openInNewWindow?: boolean;
    numberOfColumns?: number;
    maxDepth?: number;
    childrenType?: "MegaMenu" | "CascadingMenu" | "CustomLinkList";
    children?: MappedLink[];
    excludeFromNavigation?: boolean;
    // menuTitleisHighlighted?: boolean;
    dropDownValue?: string;
    customMenuImageTittle?: ImageInternalMenuLinks[];
    customMenuTitle?: string;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface NavigationDrawerStyles {
    menuTriggerButton?: ButtonPresentationProps;
    menuTriggerButtonIcon?: IconProps;
    drawer?: DrawerPresentationProps;
    drawerSectionWrapper?: InjectableCss;
    panelMenu?: PanelMenuPresentationProps;
    panelSectionWrapper?: InjectableCss;
    menuRowIcon?: IconProps;
    userRowTypography?: TypographyPresentationProps;
    punchOutUserRowText?: TypographyPresentationProps;
    mainNavigationRow?: PanelRowPresentationProps;
    mainNavigationRowIcon?: IconProps;
    punchOutNavigationRowIcon?: IconProps;
    mainNavigationRowTypography?: TypographyPresentationProps;
    logoLinks?: PanelRowPresentationProps & { typographyProps: TypographyPresentationProps };
    currencySymbol?: TypographyPresentationProps;
    changeCustomerRow?: PanelRowPresentationProps;
    changeCustomerRowContainer?: GridContainerProps;
    fulfillmentMethodGridItem?: GridItemProps;
    addressesGridItem?: GridItemProps;
    pickUpAddressGridItem?: GridItemProps;
    applyButtonGridItem?: GridItemProps;
    signOutRow?: PanelRowPresentationProps;
    signOutRowText?: TypographyPresentationProps;
    mobileViewLinkList?: InjectableCss;
    mainNaigationSubMenu?: InjectableCss;
    showInventoryToggle?: ShowInventoryToggleStyles;
    showPricingToggle?: ShowPricingToggleStyles;
}

const StyledSection = getStyledWrapper("section");
const StyledSpan = getStyledWrapper("span");

const getMenuTriggerButtonStyles = (): ButtonPresentationProps => {
    if (isThemeActive(THEME_IDS.GLOBAL_VIEWS) || isThemeActive(THEME_IDS.MGBW)) {
        return {
            shape: "pill",
            size: 50,
            color: "secondary",
            css: css`
                padding: 0 10px;
                border: none;
                background: transparent;
                &:hover {
                    background: rgba(0, 0, 0, 0.1);
                }
            `,
        };
    }

    return {
        shape: "pill",
        color: "secondary",
        size: 50,
    };
};

const getMenuTriggerButtonIconStyles = (): IconProps => {
    if (isThemeActive(THEME_IDS.GLOBAL_VIEWS) || isThemeActive(THEME_IDS.MGBW)) {
        return {
            size: 20,
            css: css`
                margin-left: 0;
            `,
        };
    }

    return {};
};

export const navigationDrawerStyles: NavigationDrawerStyles = {
    menuTriggerButton: getMenuTriggerButtonStyles(),
    menuTriggerButtonIcon: getMenuTriggerButtonIconStyles(),
    drawer: {
        size: 300,
    },
    drawerSectionWrapper: {
        css: css`
            //border-top: 1px solid #e5e5e5;
            &:first-child {
                margin-top: 0;
                padding-bottom: 0;
                background: ${getColor("common.background")};
            }

            & nav:last-child {
                margin-bottom: 5px;
            }
        `,
    },
    panelMenu: {
        cssOverrides: {
            menu: css``,
            wrapper: css`
                border-top: 1px solid ${getColor("common.backgroundContrast")};
                > button {
                    width: calc(100% - 2px);
                    background: ${getColor("background")};
                    color: ${getColor("text.main")};
                    svg {
                        height: 15px;
                        width: 15px;
                    }
                }
                a {
                    background: ${getColor("background")} !important;
                    border-bottom: 1px solid ${getColor("common.border")};
                    font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                    font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                    line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight} !important;

                    span {
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                        font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                        line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight} !important;
                    }
                }
            `,
        },
    },
    panelSectionWrapper: {
        css: css`
            height: 22px;
            display: flex;
            align-items: center;
        `,
    },
    menuRowIcon: {
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            /* border: 1px solid blue; */
        `,
    },
    userRowTypography: {
        transform: "capitalize",
        css: css`
            color: ${getColor("text.main")};
        `,
    },
    punchOutUserRowText: {
        transform: TYPOGRAPHY.header.textTransform as Property.TextTransform,
        color: "common.background",
    },
    mainNavigationRow: {
        color: "common.backgroundContrast",
        css: css`
            margin: 0px;
            border-bottom: none !important;
            padding: 20px 10px 20px 20px !important;
            &.main-navigation-row.username-row {
                background: ${getColor("secondary")};

                span {
                    font-weight: ${TYPOGRAPHY.header.weight};
                }

                .user-row-text {
                    text-transform: capitalize !important;
                    letter-spacing: normal !important;
                }

                [data-test-selector="header_userName"] {
                    text-transform: none !important;
                    letter-spacing: normal !important;

                    > span {
                        font-weight: ${TYPOGRAPHY.weight.bold} !important;
                        text-transform: none !important;
                        letter-spacing: normal !important;
                    }
                }
            }
        `,
    },
    mainNavigationRowIcon: {
        src: "User",
        size: 22,
        css: css`
            color: ${getColor("text.main")};
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    punchOutNavigationRowIcon: {
        src: "User",
        size: 22,
        css: css`
            color: ${getColor("text.main")};
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    mainNavigationRowTypography: {
        transform: (isThemeActive(THEME_IDS.MGBW) ? "uppercase" : TYPOGRAPHY.header.textTransform) as Property.TextTransform,
        color: "common.background",
        weight: "bold",
        css: css`
            ${isThemeActive(THEME_IDS.MGBW) ? `letter-spacing: 1.6px;` : ''}
        `,
    },
    mainNaigationSubMenu: {
        css: css`
            background: ${getColor("common.background")};
            ${isThemeActive(THEME_IDS.MGBW) ? `
                padding: 16px !important;
                height: 56px;
                box-sizing: border-box;
            ` : ''}
            > span {
                > svg {
                    width: 15px !important;
                    height: 15px !important;
                }
            }
            .topSeller {
                color: ${getColor("success")};
            }
            .new {
                color: ${getColor("warning")};
            }
            .clearance {
                color: ${getColor("danger")};
            }
            .makeItYours {
                font-family: ${TYPOGRAPHY.fontFamily.heading};
                font-style: italic;
                font-size: ${isThemeActive(THEME_IDS.MGBW) ? '16px' : '20px'};
                text-transform: none !important;
                letter-spacing: 1.6px;
            }
            span {
                color: ${getColor("text.main")};
                ${isThemeActive(THEME_IDS.MGBW) ? `
                    text-transform: uppercase;
                    letter-spacing: 1.6px;
                ` : ''}
            }
        `,
    },
    logoLinks: {
        color: "common.accent",
        typographyProps: {
            ellipsis: true,
            transform: (isThemeActive(THEME_IDS.MGBW) ? "none" : TYPOGRAPHY.header.textTransform) as Property.TextTransform,
        },
        css: css`
            margin: 2px;
            ${isThemeActive(THEME_IDS.MGBW) ? `
                padding: 20px 16px !important;
                background: rgba(242, 242, 242, 0.60) !important;
                border-bottom: 1px solid #E5E5E5 !important;
                span {
                    font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                    font-size: 16px !important;
                    font-weight: 500 !important;
                    line-height: 150% !important;
                    letter-spacing: 0.08px !important;
                    color: ${COLORS.text.main} !important;
                    text-transform: none !important;
                }
            ` : ''}
        `,
    },
    currencySymbol: {
        size: 22,
        css: css`
            margin-top: -4px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    changeCustomerRow: {
        css: css`
            &:focus {
                outline: none;
            }
        `,
    },
    changeCustomerRowContainer: { gap: 15 },
    fulfillmentMethodGridItem: { width: 12 },
    addressesGridItem: { width: 12 },
    pickUpAddressGridItem: { width: 12 },
    applyButtonGridItem: { width: 12 },
    signOutRowText: {
        transform: "capitalize",
        color: "text.main",
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            font-weight: ${TYPOGRAPHY.weight.baseBold} !important;
            line-height: 22px !important;
        `,
    },
    mobileViewLinkList: {
        css: css`
            margin: 10px 10px 10px 15px;
            height: 100%;
            > div {
                > div {
                    padding: 12px 0px;
                }
                div {
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-weight: ${TYPOGRAPHY.mobileViewLinksList.weight};
                    font-size: ${TYPOGRAPHY.mobileViewLinksList.size};
                    line-height: ${TYPOGRAPHY.mobileViewLinksList.lineHeight};
                    span {
                        color: ${getColor("text.main")} !important;
                    }
                }
            }
            ${isThemeActive(THEME_IDS.MGBW) ? `
                margin: 0;
                background: rgba(242, 242, 242, 0.60);
                > div > div {
                    padding: 0;
                }
                a {
                    display: block;
                    padding: 10px 16px !important;
                    border-bottom: none !important;
                    font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                    font-size: 16px !important;
                    font-weight: 500 !important;
                    line-height: 150% !important;
                    letter-spacing: 0.08px !important;
                    color: ${COLORS.text.main} !important;
                    text-transform: none !important;
                    text-decoration: none !important;
                }
            ` : ''}
        `,
    },
    showInventoryToggle: {
        toggleClickable: {
            css: css`
                text-transform: ${TYPOGRAPHY.header.textTransform};
                padding: 10px 10px 10px 20px;
            `,
        },
    },
    showPricingToggle: {
        toggleClickable: {
            css: css`
                text-transform: ${TYPOGRAPHY.header.textTransform};
                padding: 10px 10px 10px 20px;
            `,
        },
    },
};

const styles = navigationDrawerStyles;

const NavigationDrawer = ({
    links,
    showQuickOrder,
    quickOrderLink,
    displayVmiNavigation,
    vmiPageLinks,
    displayModeSwitch,
    currentMode,
    isCompactHeaderFlyout,
    currencies,
    currentCurrencyId,
    currentCurrencySymbol,
    languages,
    currentLanguage,
    currentLocation,
    userName,
    firstName,
    lastName,
    isAuthenticated,
    cart,
    isGuest,
    myAccountPageLink,
    signInUrl,
    vmiDashboardPageUrl,
    homePageUrl,
    headerLinkListLinkFields,
    showCustomerMenuItem,
    fulfillmentLabel,
    navDrawerIsOpen,
    flyoutDrawerIsOpen,
    isPunchOutSession,
    headerHeight,
    history,
    displayPricingAndInventoryToggles,
    userRole,
    isSuryaInternalUser,
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
    setFlyoutDrawerIsOpen,
    surHeaderHeight,
    removeCart,
    id,
    visibilityState,
    filterDrawer,
    userDetails,
    showFlyoutPricingToggle,
    showFlyoutInventoryToggle,
    rootElementSelector,
    allowOpenParentLinks,
    session,
}: Props) => {
    const showIcon = visibilityState === "both" || visibilityState === "icon";
    const showLabel = visibilityState === "both" || visibilityState === "label";

    const { links: headerLinkListLinks, hasMissingCategories } = useGetLinks(
        headerLinkListLinkFields,
        o => o.fields.destination,
    );

    if (hasMissingCategories) {
        return null;
    }
    const openDrawer = () => {
        const isDrawerOpen = isCompactHeaderFlyout ? flyoutDrawerIsOpen : navDrawerIsOpen;
        if (isDrawerOpen) {
            closeDrawer();
        } else {
            isCompactHeaderFlyout
                ? setFlyoutDrawerIsOpen({ isOpen: true })
                : setNavDrawerIsOpen({ navDrawerIsOpen: true });
            setInitialValues({});
            filterDrawer({ filterModal: false });
        }
    };

    const closeDrawer = () => {
        if (isCompactHeaderFlyout) {
            setFlyoutDrawerIsOpen({ isOpen: false });
            setTimeout(() => setFlyoutDrawerIsOpen({ isOpen: undefined }), 300);
            return;
        }

        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        setTimeout(() => setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    };

    const onSignOutHandler = () => {
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    const navigationModeChangeHandler = (navigationMode: "Storefront" | "Vmi") => {
        setCookie(NavigationModeCookieName, navigationMode);
        if (navigationMode === "Vmi") {
            vmiDashboardPageUrl && history.push(vmiDashboardPageUrl);
        } else if (cart?.status === "AlternateCart") {
            removeCart({
                cartId: API_URL_CURRENT_FRAGMENT,
                isAlternateCart: true,
                onSuccess: () => {
                    homePageUrl && history.push(homePageUrl);
                },
            });
        } else {
            homePageUrl && history.push(homePageUrl);
        }
    };

    const panelMenu = {
        ...(isThemeActive(THEME_IDS.MGBW) ? {
            headerColor: "background.lighter",
            backIconProps: {
                src: MGBWBackIcon,
                size: 20,
                color: "text.main",
            },
            closeIconProps: {
                src: MGBWCloseIconSmall,
                size: 16,
                color: "text.main",
            },
        } : {}),
        cssOverrides: {
            menu: css`
                padding-bottom: ${headerHeight}px;
                ${isThemeActive(THEME_IDS.MGBW) ? `
                    > a {
                        font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                        font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                        font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                        line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight} !important;
                        letter-spacing: ${TYPOGRAPHY.mobileNavCategoryLinks.letterSpacing} !important;
                        color: ${COLORS.text.main} !important;
                        text-transform: none !important;
                        padding: 16px !important;
                        height: 56px;
                        box-sizing: border-box;
                    }
                    > a span {
                        font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                        font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                        font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                        line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight} !important;
                        letter-spacing: ${TYPOGRAPHY.mobileNavCategoryLinks.letterSpacing} !important;
                        color: ${COLORS.text.main} !important;
                        text-transform: none !important;
                    }
                ` : ''}
            `,
            wrapper: css`
                border-top: 1px solid ${getColor("common.backgroundContrast")};
                ${isThemeActive(THEME_IDS.MGBW) ? `
                    > div > div:first-child {
                        background: #FAFAFA !important;
                        background-color: #FAFAFA !important;
                        padding: 12px 16px;
                        height: 44px;
                        box-sizing: border-box;
                        button {
                            background: transparent !important;
                            color: ${getColor("text.main")} !important;
                            border: none !important;
                            min-height: auto;
                            padding: 0;
                            > :first-child {
                                padding-left: 0 !important;
                            }
                            span[class*="IconWrapper"] svg {
                                width: 100% !important;
                                height: 100% !important;
                            }
                            span[class*="IconWrapper"] svg path {
                                fill: ${getColor("text.main")} !important;
                            }
                        }
                        button:last-child span[class*="IconWrapper"] svg path {
                            stroke: none !important;
                        }
                    }
                    > button {
                        font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                        font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                        font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                        line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight} !important;
                        letter-spacing: ${TYPOGRAPHY.mobileNavCategoryLinks.letterSpacing} !important;
                        text-transform: uppercase !important;
                        padding: 16px !important;
                        height: 56px;
                        box-sizing: border-box;
                        span {
                            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                            font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                            font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                            letter-spacing: ${TYPOGRAPHY.mobileNavCategoryLinks.letterSpacing} !important;
                            text-transform: uppercase !important;
                        }
                    }
                    > a {
                        font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                        font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                        font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                        line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight} !important;
                        letter-spacing: ${TYPOGRAPHY.mobileNavCategoryLinks.letterSpacing} !important;
                        text-transform: uppercase !important;
                        padding: 16px !important;
                        height: 56px;
                        box-sizing: border-box;
                        span {
                            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                            font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                            font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                            letter-spacing: ${TYPOGRAPHY.mobileNavCategoryLinks.letterSpacing} !important;
                            text-transform: uppercase !important;
                        }
                    }
                ` : ''}
                > button {
                    width: calc(100% - 2px);
                    background: ${getColor("background")};
                    color: ${getColor("text.main")};
                    > button > span > span {
                        color: ${getColor("text.main")};
                    }
                    svg {
                        height: 15px;
                        width: 15px;
                    }
                }
                div {
                    span {
                        font-weight: ${TYPOGRAPHY.header.weight};
                    }
                }

                &:first-child {
                    > button {
                        background: ${isAuthenticated
                    ? `${getColor("common.backgroundContrast")} !important`
                    : "#FFF !important"};
                        color: ${getColor("text.main")};
                        font-family: ${TYPOGRAPHY.fontFamily.base};
                        font-style: normal;
                        font-size: ${TYPOGRAPHY.size.small};
                        line-height: ${TYPOGRAPHY.lineHeight.base};
                        margin: 0px;
                        span {
                            font-weight: ${TYPOGRAPHY.header.weight};
                        }
                    }
                }

                a {
                    background: ${getColor("background")} !important;
                    border-bottom: 1px solid ${getColor("common.border")};
                    color: ${getColor("text.main")} !important;
                    font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                    font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                    line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight} !important;
                    > a {
                        border-bottom: 0;
                    }
                    span {
                        color: ${getColor("text.main")} !important;
                        font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size} !important;
                        font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight} !important;
                        line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight} !important;
                    }
                }
                span[class*="IconWrapper"] svg path {
                    stroke: ${getColor("text.main")} !important;
                }
            `,
        },
    };

    const currentPageUrl = currentLocation.pathname;
    const isOpen = isCompactHeaderFlyout ? flyoutDrawerIsOpen : navDrawerIsOpen;
    const excludeLinksMyAccount: any = siteMessage("Exclude_Links_MyAccount");
    let excludeLinksMyAccountArr: string[] = [];

    if (typeof excludeLinksMyAccount === "string" && excludeLinksMyAccount.trim() !== "") {
        excludeLinksMyAccountArr = excludeLinksMyAccount.split("|");
    }

    return (
        <>
            <Button
                className="menu-trigger-button"
                onClick={openDrawer}
                {...styles.menuTriggerButton}
                data-test-selector="expandMobileMenu"
                style={isThemeActive(THEME_IDS.GLOBAL_VIEWS) || isThemeActive(THEME_IDS.MGBW) ? { minHeight: "20px" } : undefined}
            >
                <ButtonIcon
                    className="menu-trigger-button-icon"
                    src={isThemeActive(THEME_IDS.GLOBAL_VIEWS) ? GVMenu : isThemeActive(THEME_IDS.MGBW) ? MGBWMenuIcon : Menu}
                    {...styles.menuTriggerButtonIcon}
                />
                <VisuallyHidden>{translate("menu")}</VisuallyHidden>
            </Button>

            <Drawer
                className="drawer"
                draggable
                position="left"
                {...styles.drawer}
                isOpen={isOpen}
                handleClose={closeDrawer}
                contentLabel="menu drawer"
                data-test-selector="drawerSection"
                rootElementSelector={rootElementSelector}
                cssOverrides={{
                    drawerBody: css`
                        width: 100%;
                        box-shadow: none !important;
                        transform: translate(-100%, 0);
                        background-color: ${getColor("common.backgroundContrast")};
                        top: ${headerHeight! - 1}px;
                        height: calc(100% - ${headerHeight! - 1}px);
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                css`
                                    top: ${headerHeight! - 1}px;
                                    height: calc(100% - ${headerHeight! - 1}px);
                                `,
                                css`
                                    @media (max-width: 1366px) {
                                        top: ${headerHeight! - 1}px;
                                    }
                                `,
                            ])}

                        section {
                            background: ${getColor("common.background")};
                            > a {
                                span {
                                    font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight};
                                }
                            }
                        }
                        nav {
                            color: ${getColor("text.main")};
                            font-family: ${TYPOGRAPHY.fontFamily.base};
                            font-style: normal;
                            font-size: ${TYPOGRAPHY.mobileNavCategoryLinks.size};
                            line-height: ${TYPOGRAPHY.mobileNavCategoryLinks.lineHeight};
                            > button {
                                span {
                                    font-weight: ${TYPOGRAPHY.mobileNavCategoryLinks.weight};
                                }
                            }
                        }
                    `,
                    scrim: css`
                        background: none;
                    `,
                    drawerContainer: css``,
                    drawerContent: css`
                        margin-top: -2px;
                        overflow-x: hidden;
                    `,
                    drawerTitle: css`
                        display: none;
                    `,
                }}
            >
                <StyledSection className="drawer-section-wrapper" {...styles.drawerSectionWrapper}>
                    {userName && !isGuest && !isPunchOutSession ? (
                        <PanelMenu
                            className="panel-menu"
                            currentUrl={currentPageUrl}
                            panelTrigger={
                                <PanelRow
                                    className="main-navigation-row username-row"
                                    hasChildren
                                    {...styles.mainNavigationRow}
                                >
                                    <StyledSpan className="panel-section-wrapper" {...styles.panelSectionWrapper}>
                                        <Icon className="main-navigation-row-icon" {...styles.mainNavigationRowIcon} />

                                        <StyledWrapper style={{ display: "flex", flexDirection: "column" }}>
                                            <Typography className="user-row-text" {...styles.userRowTypography}>
                                                {firstName} {lastName}
                                            </Typography>
                                            {userDetails?.customerNumber &&
                                                session?.properties?.hasMultipleCustomers === "True" && (
                                                    <Typography as="p" data-test-selector="header_userName">
                                                        As{" "}
                                                        <span style={{ fontWeight: "bolder" }}>
                                                            {userDetails?.customerNumber}{" "}
                                                        </span>
                                                    </Typography>
                                                )}
                                        </StyledWrapper>
                                    </StyledSpan>
                                </PanelRow>
                            }
                            menuItems={
                                myAccountPageLink?.children
                                    ? myAccountPageLink?.children
                                        .filter(
                                            pageLink =>
                                                !(
                                                    pageLink.title === "Financial Transactions" &&
                                                    userRole !== "Administrator" &&
                                                    userRole !== "Buyer3"
                                                ) &&
                                                !(
                                                    pageLink.title === "Manage My Users" &&
                                                    isSuryaInternalUser !== "true"
                                                ) &&
                                                !excludeLinksMyAccountArr.includes(pageLink.title) &&
                                                !(
                                                    (pageLink.title === "Order Status" ||
                                                        pageLink.title === "Upload Order" ||
                                                        pageLink.title === "Settings") &&
                                                    userRole === "Collaborator"
                                                ),
                                        )
                                        .map(pageLink => {
                                            // FIX: remove children only for Order Status
                                            if (pageLink.title === "Order Status") {
                                                return {
                                                    ...pageLink,
                                                    children: undefined,
                                                };
                                            }
                                            return pageLink;
                                        })
                                    : []
                            }
                            maxDepth={3}
                            closeOverlay={closeDrawer}
                            layer={0}
                            {...panelMenu}
                        >
                            {userName && !isGuest && (
                                <PanelRow className="sign-out-row" onClick={onSignOutHandler} {...styles.signOutRow}>
                                    <Typography className="sign-out-row-text" {...styles.signOutRowText}>
                                        {isPunchOutSession ? translate("Cancel PunchOut") : translate("Sign Out")}
                                    </Typography>
                                </PanelRow>
                            )}
                        </PanelMenu>
                    ) : (
                        isPunchOutSession && (
                            <PanelRow className="main-navigation-row" {...styles.mainNavigationRow}>
                                <StyledSpan className="panel-section-wrapper" {...styles.panelSectionWrapper}>
                                    <Icon
                                        className="punch-out-navigation-row-icon"
                                        {...styles.punchOutNavigationRowIcon}
                                    />
                                    <Typography className="punch-out-user-row-text" {...styles.punchOutUserRowText}>
                                        {userName}
                                    </Typography>
                                </StyledSpan>
                            </PanelRow>
                        )
                    )}

                    {/* covers MainNavigation functionality */}
                    {!displayVmiNavigation &&
                        links.map((link, index) => {
                            if (
                                !!link.childrenType &&
                                link.children &&
                                link.children.filter(o => !o.excludeFromNavigation).length > 0
                            ) {
                                const href =
                                    allowOpenParentLinks && link.url && link.url !== currentPageUrl
                                        ? link.url
                                        : undefined;
                                return (
                                    <PanelMenu
                                        className="panel-menu"
                                        key={index}
                                        currentUrl={currentPageUrl}
                                        closeOverlay={closeDrawer}
                                        panelTrigger={
                                            <PanelRow
                                                className="main-navigation-row"
                                                href={href}
                                                isCurrent={link.url === currentPageUrl}
                                                hasChildren={true}
                                                allowOpenParentLinks={allowOpenParentLinks}
                                                {...styles.mainNaigationSubMenu}
                                            >
                                                <Link href={link.url} onClick={closeDrawer}>
                                                    <Typography
                                                        className={`main-navigation-row-text ${link.dropDownValue}`}
                                                        {...styles.mainNavigationRowTypography}
                                                    >
                                                        {link.title}
                                                    </Typography>
                                                </Link>
                                            </PanelRow>
                                        }
                                        menuItems={link.children}
                                        maxDepth={link.maxDepth || 3}
                                        layer={0}
                                        allowOpenParentLinks={allowOpenParentLinks}
                                        {...panelMenu}
                                    >
                                        {isThemeActive(THEME_IDS.MGBW) && link.customMenuImageTittle && link.customMenuImageTittle.length > 1 && (() => {
                                            const sbc = (ELEMENTS as any).shopByCollection || {};
                                            const heading = link.customMenuTitle || sbc.heading || "SHOP BY COLLECTION";
                                            return (
                                                <StyledWrapper
                                                    css={css`
                                                        display: flex;
                                                        padding: 0;
                                                        flex-direction: column;
                                                        align-items: stretch;
                                                        align-self: stretch;
                                                    `}
                                                >
                                                    <Typography
                                                        weight="bold"
                                                        css={css`
                                                            display: flex;
                                                            align-items: center;
                                                            font-size: 16px;
                                                            font-weight: 700 !important;
                                                            letter-spacing: 1.6px;
                                                            text-transform: uppercase;
                                                            padding: 0 0 0 16px;
                                                            height: 56px;
                                                            box-sizing: border-box;
                                                            border-top: 1px solid ${getColor("common.border")};
                                                        `}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                    {link.customMenuImageTittle!.map((tile, tileIdx) => (
                                                        <a
                                                            key={tileIdx}
                                                            href={tile.fields.internalImgTitledestination || "#"}
                                                            onClick={closeDrawer}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "16px",
                                                                padding: "0 0 0 16px",
                                                                borderTop: `1px solid ${COLORS.border || "#e5e5e5"}`,
                                                                borderBottom: `1px solid ${COLORS.border || "#e5e5e5"}`,
                                                                textDecoration: "none",
                                                                color: "inherit",
                                                            }}
                                                        >
                                                            <img
                                                                src={tile.fields.internalImgURL}
                                                                alt={tile.fields.internalImgTitle}
                                                                style={{
                                                                    width: "90px",
                                                                    height: "90px",
                                                                    aspectRatio: "1/1",
                                                                    objectFit: "cover",
                                                                    flexShrink: 0,
                                                                }}
                                                            />
                                                            <Typography
                                                                css={css`
                                                                    font-family: ${TYPOGRAPHY.fontFamily.base} !important;
                                                                    font-size: 16px !important;
                                                                    font-weight: 500 !important;
                                                                    line-height: 150% !important;
                                                                    letter-spacing: 0.08px !important;
                                                                    color: ${COLORS.text.main} !important;
                                                                    text-transform: none !important;
                                                                `}
                                                            >
                                                                {tile.fields.internalImgTitle}
                                                            </Typography>
                                                        </a>
                                                    ))}
                                                </StyledWrapper>
                                            );
                                        })()}
                                    </PanelMenu>
                                );
                            }
                            return (
                                <PanelRow
                                    key={index}
                                    href={link.url}
                                    target={link.openInNewWindow ? "_blank" : ""}
                                    className="main-navigation-row"
                                    onClick={closeDrawer}
                                    {...styles.mainNaigationSubMenu}
                                >
                                    <Typography
                                        className={`main-navigation-row-text ${link.dropDownValue}`}
                                        {...styles.mainNavigationRowTypography}
                                    >
                                        {link.title}
                                    </Typography>
                                </PanelRow>
                            );
                        })}
                    {!displayVmiNavigation && showQuickOrder && quickOrderLink && (
                        <PanelRow
                            className="main-navigation-row"
                            isCurrent={currentPageUrl === quickOrderLink.url}
                            onClick={closeDrawer}
                            href={quickOrderLink.url}
                            {...styles.mainNaigationSubMenu}
                        >
                            <Typography className="main-navigation-row-text" {...styles.mainNavigationRowTypography}>
                                {quickOrderLink.title}
                            </Typography>
                        </PanelRow>
                    )}
                    {displayVmiNavigation &&
                        vmiPageLinks &&
                        vmiPageLinks.map(
                            link =>
                                link && (
                                    <PanelRow
                                        className="main-navigation-row"
                                        key={link.id}
                                        isCurrent={currentPageUrl === link.url}
                                        onClick={closeDrawer}
                                        href={link.url}
                                        {...styles.mainNaigationSubMenu}
                                    >
                                        <Typography
                                            className="main-navigation-row-text"
                                            {...styles.mainNavigationRowTypography}
                                        >
                                            {link.title}
                                        </Typography>
                                    </PanelRow>
                                ),
                        )}
                </StyledSection>
                {headerLinkListLinks.length > 0 && (
                    <StyledSection className="drawer-section-wrapper" {...styles.drawerSectionWrapper}>
                        {headerLinkListLinks.map((link, index) => (
                            <PanelRow
                                className="logo-links-row"
                                key={link.title + String(index)}
                                {...(styles.logoLinks && omitSingle(styles.logoLinks, "typographyProps"))}
                                isCurrent={currentPageUrl === link.url}
                                onClick={closeDrawer}
                                onKeyUp={(event: React.KeyboardEvent<HTMLAnchorElement>) => {
                                    if (event.key === " " && history && link?.url) {
                                        event.preventDefault();
                                        closeDrawer();
                                        history.push(link.url);
                                    }
                                }}
                                href={link.url}
                                target={headerLinkListLinkFields[index].fields.openInNewWindow ? "_blank" : ""}
                            >
                                <Typography className="logo-link-title" {...styles.logoLinks?.typographyProps}>
                                    {link.title}
                                </Typography>
                            </PanelRow>
                        ))}
                    </StyledSection>
                )}
                <StyledSection className="drawer-section-wrapper" {...styles.drawerSectionWrapper}>
                    <SelectorMenu
                        options={currencies?.map(c => {
                            return {
                                title: c.currencyCode.toUpperCase(),
                                clickableProps: {
                                    onClick: () => {
                                        setCurrency({ currencyId: c.id });
                                        closeDrawer();
                                    },
                                },
                            };
                        })}
                        closeModal={closeDrawer}
                        currentOption={currencies?.find(c => c.id === currentCurrencyId)?.currencyCode}
                        currentOptionIcon={<Typography {...styles.currencySymbol}>{currentCurrencySymbol}</Typography>}
                    />
                    <SelectorMenu
                        dataTestSelector="mobileLanguageSelector"
                        options={languages?.map(l => {
                            return {
                                title: l.languageCode.toUpperCase(),
                                clickableProps: {
                                    onClick: () => {
                                        setLanguage({ languageId: l.id });
                                        closeDrawer();
                                    },
                                },
                            };
                        })}
                        currentOption={currentLanguage?.languageCode}
                        closeModal={closeDrawer}
                        currentOptionIcon={
                            currentLanguage?.imageFilePath ? (
                                <LogoImage className="language-image" src={currentLanguage.imageFilePath} alt="" />
                            ) : (
                                <Icon className="menu-row-icon" src={Globe} {...styles.menuRowIcon} />
                            )
                        }
                    />
                    {/* {showCustomerMenuItem && (
                        <PanelMenu
                            className="panel-menu"
                            {...styles.panelMenu}
                            panelTrigger={
                                <PanelRow
                                    hasChildren
                                    className="logo-links-row"
                                    {...styles.logoLinks}
                                    color="common.accent"
                                >
                                    <Typography className="logo-link-title" {...styles.logoLinks?.typographyProps}>
                                        <Icon src={MapPin} className="menu-row-icon" {...styles.menuRowIcon} />
                                        {fulfillmentLabel}
                                    </Typography>
                                </PanelRow>
                            }
                            layer={0}
                            closeOverlay={closeDrawer}
                        >
                            {isPunchOutSession ? (
                                <PanelRow tabIndex={-1} className="change-customer-row" {...styles.changeCustomerRow}>
                                    {createWidgetElement("Header/AddressDrawerPunchOutCustomer", {
                                        fields: {},
                                    })}
                                </PanelRow>
                            ) : (
                                <PanelRow tabIndex={-1} className="change-customer-row" {...styles.changeCustomerRow}>
                                    <GridContainer
                                        className="change-customer-row-container"
                                        {...styles.changeCustomerRowContainer}
                                    >
                                        <GridItem
                                            className="fulfillment-method-grid-item"
                                            {...styles.fulfillmentMethodGridItem}
                                        >
                                            {createWidgetElement("Header/AddressDrawerFulfillmentMethodSelector", {
                                                fields: {},
                                            })}
                                        </GridItem>
                                        <GridItem className="addresses-grid-item" {...styles.addressesGridItem}>
                                            {createWidgetElement("Header/AddressDrawerSelectCustomer", {
                                                fields: {},
                                            })}
                                        </GridItem>
                                        <GridItem
                                            className="pick-up-address-grid-item"
                                            {...styles.pickUpAddressGridItem}
                                        >
                                            {createWidgetElement("Header/AddressDrawerPickUpLocationSelector", {
                                                fields: {},
                                            })}
                                        </GridItem>
                                        <GridItem className="apply-button-grid-item" {...styles.applyButtonGridItem}>
                                            {createWidgetElement("Header/AddressDrawerApplyButton", { fields: {} })}
                                        </GridItem>
                                    </GridContainer>
                                </PanelRow>
                            )}
                        </PanelMenu>
                    )} */}
                    {displayModeSwitch && (
                        <SelectorMenu
                            options={[
                                {
                                    title: translate("Storefront"),
                                    clickableProps: {
                                        onClick: () => {
                                            navigationModeChangeHandler("Storefront");
                                            closeDrawer();
                                        },
                                    },
                                },
                                {
                                    title: translate("Vendor Managed Inventory"),
                                    clickableProps: {
                                        onClick: () => {
                                            navigationModeChangeHandler("Vmi");
                                            closeDrawer();
                                        },
                                    },
                                },
                            ]}
                            closeModal={closeDrawer}
                            currentOption={
                                currentMode === "Vmi" ? translate("Vendor Managed Inventory") : translate("Storefront")
                            }
                        />
                    )}
                    {displayPricingAndInventoryToggles && (
                        <>
                            {(!isCompactHeaderFlyout || showFlyoutInventoryToggle) && (
                                <ShowInventoryToggle extendedStyles={styles.showInventoryToggle} />
                            )}
                            {(!isCompactHeaderFlyout || showFlyoutPricingToggle) && (
                                <ShowPricingToggle extendedStyles={styles.showPricingToggle} />
                            )}
                        </>
                    )}
                    {/* {userName && !isGuest && (
                        <PanelRow className="sign-out-row" onClick={onSignOutHandler} {...styles.signOutRow}>
                            <Typography className="sign-out-row-text" {...styles.signOutRowText}>
                                {isPunchOutSession ? translate("Cancel PunchOut") : translate("Sign Out")}
                            </Typography>
                        </PanelRow>
                    )} */}
                </StyledSection>
                <StyledWrapper {...styles.mobileViewLinkList}>
                    <Zone contentId={id} zoneName="Content1"></Zone>
                </StyledWrapper>
            </Drawer>
        </>
    );
};

const LogoImage = styled.img`
    margin-right: 10px;
    height: 22px;
`;

interface SelectorMenuProps {
    options?: MappedLink[];
    closeModal?: () => void;
    currentOption?: string;
    currentOptionIcon?: React.ReactNode;
    dataTestSelector?: string;
}

const SelectorMenu: React.FC<SelectorMenuProps> = ({
    options,
    closeModal,
    currentOption,
    currentOptionIcon,
    dataTestSelector,
}) => {
    if (!options || options.length <= 1) {
        return null;
    }

    const trigger = (
        <PanelRow hasChildren className="logo-links-row" {...styles.logoLinks}>
            <StyledSpan className="panel-section-wrapper" {...styles.panelSectionWrapper}>
                {currentOptionIcon}
                <Typography
                    className="logo-link-title"
                    data-test-selector={`${dataTestSelector}_currentOption`}
                    {...styles.logoLinks?.typographyProps}
                >
                    {currentOption}
                </Typography>
            </StyledSpan>
        </PanelRow>
    );

    return (
        <PanelMenu
            className="panel-menu"
            currentUrl={currentOption}
            data-test-selector={dataTestSelector}
            closeOverlay={closeModal}
            panelTrigger={trigger}
            menuItems={options}
            maxDepth={1}
            layer={0}
            {...styles.panelMenu}
        />
    );
};

function findVisibilityState(data: any): string | undefined {
    for (const key in data) {
        if (data[key].type === "Common/HeaderSignIn") {
            return data[key].generalFields.visibilityState;
        }
    }
    return undefined;
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(NavigationDrawer));
